const DEVELOPER_MODE_KEY = "developer_mode";

export function readDeveloperMode() {
  return localStorage.getItem(DEVELOPER_MODE_KEY) === "true";
}

export function writeDeveloperMode(enabled) {
  localStorage.setItem(DEVELOPER_MODE_KEY, enabled ? "true" : "false");
}
